/**
 * author: Patrick Vyn Badiang
 *
 * Description:
 *
 * Is used for any section
 * Depending on whether or not specific props exist,
 * itll then display accordingly
 *
 * Ex: If it has props.subText then it'll create a text area
 * But if there is no props.subText and it has a props.photo
 * then it'll create a photo component
 */
import { Box, Typography } from "@mui/material";
import { mustard } from "../../../styles.tsx";

const Section = ({ text, bgcolor = "primary.main", color = mustard }) => {
  return (
    <Box sx={{ bgcolor, px: { xs: "20px", md: "48px" }, pt: { xs: "48px", md: "90px" } }}>
      <Typography variant="h2" sx={{ color, maxWidth: "1200px", mx: "auto" }}>
        {text}
      </Typography>
    </Box>
  );
};

export default Section;
